import GraphVisualization from './GraphVisualization';
import './GraphVisualization.scss';

export { schema, uiSchema } from '../schemas/GraphVisualizationSchema';
export default GraphVisualization;
